import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  TextField,
  useMediaQuery,
  CardContent,
  Card,
} from "@mui/material";
import { ItemCard } from "./Component/ItemCard";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Barcode_Set, Item_Set } from "./SliceSegregation";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import BreadCrumbs from "./Component/BreadCrumbs";
import { SegregationRo, vRdxUserInfo } from "../../Redux/roStore";
import {
  SegregationDetail_GetRow,
  SegregationLocation_Detail,
  SegregationLocation_Pending_Detail,
} from "../../Server/ApiV2";
import ViewList from "./Component/ViewList";
import moment from "moment";
import { CmpStatusIcon, CmpStatusIconV3, CmpStatusIconV4 } from "../../Component/Common/ToolBox/ToolBox";
// import { Card } from "react-bootstrap";

const SegregationItemScan = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [viewData, setViewData] = useState([]);
  const [data, setData] = useState([
    // {
    //   "L_Loc": "DX0076",
    //   "LocName": "AL SHAAB SUPERMARKET",
    //   "TotalBaseQty": 240,
    //   "TotalPickedQty": 0,
    //   "BalanceQty": 240,
    //   "L_DropID": null,
    //   "ItmCd": "100197986",
    //   "ItmName": "HOMEY CHICKPEAS BLACK 1 KG"
    // }
  ]);
  const [view, setView] = useState(false);
  const [filter, setFilter] = useState("");
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const vRdxHead = useSelector((state) => state.SliceSegregation.value.Head);
  const vRdxBarcode = useSelector(
    (state) => state.SliceSegregation.value.Barcode
  );
  const handleLoad = async (xfilter = filter) => {
    dispatch(Barcode_Set(xfilter));
    const { Head } = SegregationRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    const Obj = {
      VocTyp: Head.A_VocTyp,
      VocNo: Head.A_VocNo,
      Barcode: xfilter,
      Loc: "",
    };
    let resp = await SegregationDetail_GetRow(
      fcheck_null_undefine_replace_empty(Obj)
    );
    if (resp?.status === 200) {
      let respData = resp?.data?.ResultSet;
      const updatedData = respData
        .map((item) => {
          let indicator;
          if (item.BalanceQty === 0) {
            indicator = 3; // Green
          } else if (item.TotalPickedQty > 0) {
            indicator = 1; // Yellow
          } else {
            indicator = 2; // Red
          }
          return {
            ...item, // Spread existing properties
            Indicator: indicator, // Add the new key
          };
        })
        ?.sort((a, b) => a.Indicator - b.Indicator);
      setData(updatedData);
      setFilter("");
    } else {
      setData([]);
    }
    setTimeout(async () => {
      document.getElementsByName("Barcode")[0]?.focus();
    }, 200);
  };
  useEffect(() => {
    if (vRdxBarcode != "") {
      handleLoad(vRdxBarcode);
    }
    setTimeout(async () => {
      document.getElementsByName("Barcode")[0]?.focus();
    }, 200);
  }, []);

  const handleFilter = (xfilter = filter) => {
    if (xfilter == "") {
      fAlertToast("FAILED", "Barcode should not be empty");
    } else {
      handleLoad();
    }
  };
  const fOnRowClick = async (e) => {
    let {
      L_Loc,
      LocName,
      TotalBaseQty,
      TotalPickedQty,
      BalanceQty,
      L_DropID,
      ItmName,
      ItmCd,
      Status,
      A_SegregationMethod = "",
      UnitId = "",
    } = e.row;
    console.log(e.row);

    dispatch(
      Item_Set({
        L_Loc: L_Loc,
        LocName: LocName,
        TotalBaseQty: TotalBaseQty,
        TotalPickedQty: TotalPickedQty,
        BalanceQty: BalanceQty,
        L_DropID: L_DropID || "",
        ItmName: ItmName,
        ItmCd: ItmCd,
        Status: Status || "ENTER",
        A_SegregationMethod: A_SegregationMethod || "",
        UnitId: UnitId || "",
      })
    );

    navigate("/segregrationDetail");
  };

  // Function to group data by Location


 
  return (
    // <div style={{ margin: {md:"40px" ,sm:"5px" , xs:"5px"} }}>
    <div style={{ margin: vMediaQuery ? "1px" : "40px" }}>
      <div className="mb-3">
        <BreadCrumbs />
      </div>

      {!vMediaQuery &&<Grid container spacing={1} p={1.5}>
        <Grid item xs={12} sm={6} md={4}>
          <Grid container>
            <Grid item xs={4} md={2.8}>
              <Typography variant="subtitle1" component="span">
                Doc.No
              </Typography>
            </Grid>
            <Grid item xs={0.5} md={1}>
              <Typography variant="subtitle1" component="span">
                :
              </Typography>
            </Grid>
            <Grid item xs={7.5} md={8.2}>
              <Typography variant="subtitle1" component="span">
                {" "}
                {vRdxHead.A_VocNo}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Grid container>
            <Grid item xs={4} md={2.8}>
              <Typography variant="subtitle1" component="span">
                Date
              </Typography>
            </Grid>
            <Grid item xs={0.5} md={1}>
              <Typography variant="subtitle1" component="span">
                :
              </Typography>
            </Grid>
            <Grid item xs={7.5} md={8.2}>
              <Typography variant="subtitle1" component="span">
                {" "}
                {moment(vRdxHead.A_VocDt).format("DD/MM/YYYY")}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={12} sm={6} md={4}>
          <Grid container>
            <Grid item xs={4} md={2.8}>
              <Typography variant="subtitle1" component="span">
                Slot.Id
              </Typography>
            </Grid>
            <Grid item xs={0.5} md={1}>
              <Typography variant="subtitle1" component="span">
                :
              </Typography>
            </Grid>
            <Grid item xs={7.5} md={8.2} component="span">
              <Typography variant="subtitle1"> {vRdxHead.NumberID}</Typography>
            </Grid>
          </Grid>
        </Grid> */}
        <Grid item xs={12} sm={6} md={4}>
          <Grid container>
            <Grid item xs={4} md={2.8}>
              <Typography variant="subtitle1" component="span">
                Status
              </Typography>
            </Grid>
            <Grid item xs={0.5} md={1}>
              <Typography variant="subtitle1" component="span">
                :
              </Typography>
            </Grid>
            <Grid item xs={7.5} md={8.2}>
              <Typography variant="subtitle1" component="span">
                {vRdxHead.Status}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Grid container>
            <Grid item xs={4} md={2.8}>
              <Typography variant="subtitle1" component="span">
                Segregation
              </Typography>
            </Grid>
            <Grid item xs={0.5} md={1}>
              <Typography variant="subtitle1" component="span">
                :
              </Typography>
            </Grid>
            <Grid item xs={7.5} md={8.2}>
              <Typography variant="subtitle1" component="span">
                {vRdxHead.SegregationMethod}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
       
      </Grid>}
      {vMediaQuery &&<Grid container spacing={2}  >
      <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}  
        >
          <Card
            sx={{
              borderRadius: 3,
              boxShadow: 3,
              "& .MuiCardContent-root": {
                padding: "0px !important",
              },
            }}
          >
            <CardContent>
              <Box sx={{ backgroundColor: "#FAF9F6", p: 1.5 }}>
                {/* Name and Position */}
                <Grid container>
                  <Grid item xs={11}>
                    <Typography variant="h6" fontWeight="bold">
                    {vRdxHead.A_VocNo}
                    </Typography>
                    <Typography variant="subtitle2"  >
                      {moment(vRdxHead.A_VocDt).format("DD/MM/YYYY")}
                    </Typography>
                    <Typography variant="subtitle2"  >
                    <strong> Segregation:</strong> {vRdxHead.SegregationMethod}
                    </Typography>
                  </Grid>
                  {/* <Grid item xs={1} textAlign={'right'}>
                    <CmpStatusIconV2 xStatus={item.Status}  />
                  </Grid> */}
                  <Grid item xs={1} textAlign={'right'}>
                    <CmpStatusIcon xStatus={vRdxHead?.Status}  />
                  </Grid>
                </Grid>
              </Box>
              
              {/* <Grid container spacing={1} p={1.5}>
               
                <Grid item xs={6}>
                  <Grid container>
                    <Grid item xs={5.7} md={4.6}>
                      <Typography variant="body2" component="span">
                        Qty
                      </Typography>
                    </Grid>
                    <Grid item xs={0.5} md={0.5}>
                      <Typography variant="body2" component="span">
                        :
                      </Typography>
                    </Grid>
                    <Grid item xs={5.8} md={6.9}>
                      <Typography variant="body2"> {item.L_BaseQty}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Grid container>
                    <Grid item xs={5.7} md={4.6}>
                      <Typography variant="body2" component="span">
                        Picked
                      </Typography>
                    </Grid>
                    <Grid item xs={0.5} md={0.5}>
                      <Typography variant="body2" component="span">
                        :
                      </Typography>
                    </Grid>
                    <Grid item xs={5.8} md={6.9} component="span">
                      <Typography variant="body2">
                        {(item.TotalPickedQty).toFixed(0)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Grid container>
                    <Grid item xs={5.7} md={4.8}>
                      <Typography variant="body2" component="span">
                         %
                      </Typography>
                    </Grid>
                    <Grid item xs={0.5} md={0.5}>
                      <Typography variant="body2" component="span">
                        :
                      </Typography>
                    </Grid>
                    <Grid item xs={5.8} md={6.7}>
                      <Typography variant="body2" component="span">
                        {" "}
                        {item.CompletionPercentage.toFixed(2)} 
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid> */}
            </CardContent>
          </Card>
        </Grid>
      </Grid>}
      <Grid
        container
        spacing={0.5}
        style={{ margin: "12px 0px", alignItems: "center" }}
      >
        <Grid item xs={7} md={4}>
          <TextField
            fullWidth
            label="Barcode Scan"
            name={"Barcode"}
            variant="outlined"
            value={filter}
            onChange={(e) => {
              setFilter(e.target.value);
            }}
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                handleFilter();
              }
            }}
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0.5,
                borderColor: "#1976d2",
              },
            }}
          />
        </Grid>
        <Grid item xs={"auto"}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => handleFilter()}
            size="small"
          >
            Load
          </Button>
        </Grid>
        <Grid item xs={"auto"}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => {
              setView(true);
            }}
            size="small"
          >
            View
          </Button>
        </Grid>
      </Grid>
      <ItemCard
        data={data}
        onClick={(items) => {
          fOnRowClick(items);
        }}
        vMediaQuery={vMediaQuery}
      />
    
      <ViewList
        open={view}
        fCloseSearchModal={() => {
          setView(false);
        }}
      />
    </div>
  );
};

export default SegregationItemScan;
